import {FormControl, FormHelperText, FormLabel, Typography} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import React, {useContext, useEffect, useState} from 'react';
import {FormContext, useForm} from 'react-hook-form';
import {withRouter} from 'react-router-dom';
import {useSnackbar} from 'notistack';
import TipoPerfil from '../../../constants/tipoPerfil';
import {findByCep} from '../../../services/cep/CepService';
import {buscarPorEmail} from '../../../services/convite/ConviteService';
import {AppContext} from '../../shared/context';
import Mascara from '../../shared/form/mascaras';
import ConselheiroForm from '../conselheiro/conselheiroForm';
import EquipeTecnicaForm from '../equipeTecnica/equipeTecnicaForm';
import InterlocutorForm from '../interlocutor/interlocutorForm';
import CabecalhoCadastro from './cabecalhoCadastro';
import CabecalhoEdicao from './cabecalhoEdicao';
import useStyles from './styles';
import Formatos from '../../../helpers/formatos';
import {recuperarAtuacoes} from "../../../services/usuario/UsuarioService";
import {DeleteOutlined} from "@material-ui/icons";
import {uploadStorage} from "../../../services/documento/DocumentoService";

const UsuarioForm = (props) => {
  const {keycloak} = useContext(AppContext);
  const {tokenParsed} = keycloak;
  const {tipo, onSubmit, labelBotao, listaPerfis} = props;
  const initialValue = props.initialValue || {};
  const {
    register, handleSubmit, errors, setValue, clearError, unregister,
  } = useForm();

  const classes = useStyles();
  const [convidado, setConvidado] = useState(false);
  const {enqueueSnackbar} = useSnackbar();
  const [atuacoes, setAtuacoes] = useState([]);
  const [perfis, setPerfis] = useState([]);

  const clearEquipeTecnicaForm = () => {
    unregister('ocupacaoEquipeTecnica');
  };

  const clearInterlocutorForm = () => {
    unregister('idEntidadeConselheiro');
    unregister('idTitularidadeConselheiro');
    unregister('idConselheiro');
    unregister('idConselhoInterlocutor');
    unregister('ocupacaoInterlocutor');
  };

  const clearConselheiroForm = () => {
    unregister('idTitularidade');
    unregister('idEntidade');
    unregister('nomeInterlocutor');
    unregister('funcaoNaEntidadeInterlocutor');
    unregister('telefoneInterlocutor');
    unregister('emailInterlocutor');
    unregister('inicioDoMandato');
    unregister('fimDoMandato');
    unregister('idConselhoConselheiro');
    unregister('ocupacaoConselheiro');
  }

  const handleFormCleanValidation = (id = -1) => {
    const perfisChecks = {1: 0, 2: 0, 3: 0};
    if (id in perfisChecks) {
      perfisChecks[id]--;
    }
    if (perfis.length > 0) {
      for (const perfilUser of perfis) {
        perfisChecks[perfilUser.tipoPerfil]++;
      }
      if (!perfisChecks[1]) {
        clearConselheiroForm();
      }
      if (!perfisChecks[2]) {
        clearEquipeTecnicaForm();
      }
      if (!perfisChecks[3]) {
        clearInterlocutorForm();
      }
    }
  }

  const mappedValues = {
    'ocupacaoEquipeTecnica': 'ocupacao',
    'ocupacaoConselheiro': 'ocupacao',
    'ocupacaoInterlocutor': 'ocupacao',
    'idConselhoConselheiro': 'idConselho',
    'idConselhoInterlocutor': 'idConselho',
  }

  const initialState = {
    // avatar: '',
    id: initialValue.id || '',
    sub: initialValue.sub || tokenParsed.sub,
    nome: initialValue.nome || tokenParsed.given_name,
    sobrenome: initialValue.sobrenome || tokenParsed.family_name,
    emailInstitucional: initialValue.emailInstitucional || tokenParsed.email,
    linkedIn: initialValue.linkedIn || '',
    celular: initialValue.celular || '',
    telefone: initialValue.telefone || '',
    idAtuacao: initialValue.idAtuacao || 1,
    cep: initialValue.cep || '',
    endereco: initialValue.endereco || '',
  };

  const [form, setForm] = useState(initialState)
  const handleChange = (event) => {
    const {name, value} = event.target;
    setValue(name, value, true)
    setForm({...form, [mappedValues[name] ?? name]: value ? value : null})
  };

  const initialStateConselheiro = {
    idTitularidade: initialValue.idTitularidade || '',
    idEntidade: initialValue.idEntidade || '',
    funcaoNaEntidade: initialValue.funcaoNaEntidade || '',
    idConselho: initialValue.idConselho || '',
    idComissaoComite: initialValue.idComissaoComite || '',
    nomeInterlocutor: initialValue.nomeInterlocutor || '',
    funcaoNaEntidadeInterlocutor: initialValue.funcaoNaEntidadeInterlocutor || '',
    telefoneInterlocutor: initialValue.telefoneInterlocutor || '',
    emailInterlocutor: initialValue.emailInterlocutor || '',
    idTermoPosse: initialValue.idTermoPosse || '',
    nomeTermoPosse: initialValue.nomeTermoPosse || '',
    tamanhoTermoPosse: initialValue.tamanhoTermoPosse || '',
    damTermoPosse: initialValue.damTermoPosse || '',
    formatoTermoPosse: initialValue.formatoTermoPosse || null,
    dataInclusaoTermoPosse: initialValue.dataInclusaoTermoPosse || '',
    novoTermoPosse: false,
    inicioDoMandato: initialValue.inicioDoMandato || '',
    fimDoMandato: initialValue.fimDoMandato || '',
    ativo: initialValue.ativo || true,
    aprovado: initialValue.aprovado || '',
  };

  const [conselheiroPerfil, setConselheiroPerfil] = useState(initialStateConselheiro);
  const handleChangeConselheiroPerfil = (index) => (event) => {
    let lista = [...perfis];

    const {name, value} = event.target;
    setValue(name, value, true);

    lista[index].conselheiroPerfil = {
      ...lista[index].conselheiroPerfil,
      [mappedValues[name] ?? name]: value ? value : null
    };
    setPerfis([...lista]);
  };

  const handleChangeEquipeTecnicaForm = (index) => (event) => {
    let lista = [...perfis];

    const {name, value} = event.target
    setValue(name, value, true);

    // lista[index].equipeTecnicaFrom = { ...lista[index].equipeTecnicaFrom, [mappedValues[name] ?? name]: value ? value : null };
    lista[index].ocupacao = value;
    setPerfis([...lista]);
  };

  const initialStateInterlocutor = {
    idEntidadeConselheiro: initialValue.idEntidadeConselheiro || '',
    funcaoNaEntidade: initialValue.funcaoNaEntidade || '',
    idTitularidadeConselheiro: initialValue.idTitularidadeConselheiro || '',
    idConselheiro: initialValue.idConselheiro || '',
    idConselho: initialValue.idConselho || '',
    ativo: initialValue.ativo || true,
    aprovado: initialValue.aprovado || '',
    idEntidade: initialValue.idEntidade || '',
  };

  const [interlocutorPerfil, setInterlocutorPerfil] = useState(initialStateInterlocutor);
  const handleChangeInterlocutorPerfil = (index) => (event) => {
    let lista = [...perfis];

    const {name, value} = event.target;
    setValue(name, value)

    clearError(name);
    if (name === 'idTitularidadeConselheiro') {
      setValue('idConselheiro', '');
      lista[index].interlocutorPerfil = {
        ...lista[index].interlocutorPerfil,
        [mappedValues[name] ?? name]: value ? value : null,
        idConselheiro: ''
      };
    } else {
      lista[index].interlocutorPerfil = {
        ...lista[index].interlocutorPerfil,
        [mappedValues[name] ?? name]: value ? value : null
      }
    }
    setPerfis([...lista]);
  };

  function adicionarLinha() {
    let lista = [...perfis];
    lista.push({
      tipoPerfil: '',
      idAtuacao: '',
      ocupacao: '',
      ativo: true,
      aprovado: '',
      idEntidade: ''
    });

    setPerfis([...lista])

  }

  const removerLinha = (index, id) => (event) => {
    let lista = [...perfis];

    if (lista[index].id) {
      lista[index].ativo = false;
    } else {
      lista.splice(index, 1);
    }

    setPerfis([...lista]);

    handleFormCleanValidation(id);
  }
  const verificarPerfilInativo = (index, item) => {
    let lista = [...perfis];
    console.log(lista);
    for (let j = 0; j < perfis.length; ++j) {
      if (index !== j && item.idAtuacao === perfis[j].idAtuacao && item.tipoPerfil === perfis[j].tipoPerfil) {
        lista.splice(index, 1);
        perfis[j].ativo = true;
        enqueueSnackbar("Perfil existente encontrado!", {variant: 'success'});
      }
    }

    setPerfis([...lista]);
  }


  const handleChangePerfil = (index) => (event) => {
    const {name, value} = event.target;
    setValue(name, value, true)

    let lista = [...perfis];

    if (value === TipoPerfil.CONSELHEIRO.id) {
      lista[index] = {
        ...lista[index],
        conselheiroPerfil: conselheiroPerfil,
        ocupacao: '',
        interlocutorPerfil: null
      };
    } else if (value === TipoPerfil.EQUIPE_TECNICA.id) {
      lista[index] = {
        ...lista[index],
        conselheiroPerfil: null,
        ocupacao: '',
        interlocutorPerfil: null
      };
    } else if (value === TipoPerfil.INTERLOCUTOR.id) {
      lista[index] = {
        ...lista[index],
        conselheiroPerfil: null,
        ocupacao: '',
        interlocutorPerfil: interlocutorPerfil
      };
    }

    lista[index].tipoPerfil = value;
    setPerfis([...lista]);
  };

  const handleChangeLista = (index) => (event) => {
    const {name, value} = event.target;
    setValue(name, value, true)

    let lista = [...perfis];
    lista[index] = {...lista[index], [mappedValues[name] ?? name]: value ? value : null};
    setPerfis([...lista]);
  };

  useEffect(() => {
    // register({ name: 'tipoPerfil' }, { required: 'Tipo de Perfil é obrigatório' });
    register({name: 'celular'}, {
      required: 'Celular é obrigatório',
      minLength: {value: 15, message: 'Formato inválido'}
    });
    register({name: 'telefone'}, {
      required: 'Telefone é obrigatório',
      minLength: {value: 14, message: 'Formato inválido'}
    });
    register({name: 'cep'}, {required: 'CEP é obrigatório', minLength: {value: 9, message: 'Formato inválido'}});
    register({name: 'endereco'}, {required: 'Endereço é obrigatório'});

    // setValue('tipoPerfil', initialState.tipoPerfil);
    setValue('celular', Formatos.celular(initialState.celular));
    setValue('telefone', Formatos.telefone(initialState.telefone));
    setValue('cep', Formatos.cep(initialState.cep));
    setValue('endereco', initialState.endereco);

    clearError();
    setForm(initialState);
    setConselheiroPerfil(initialStateConselheiro);
    // setEquipeTecnicaFrom(initialStateEquipeTecnica);
    setInterlocutorPerfil(initialStateInterlocutor);
    // // eslint-disable-next-line react-hooks/exhaustive-deps

    if (tipo === 'cadastrar') {
      buscarPorEmail(initialState.emailInstitucional).then((response) => {
        if (response && response.status === 200) {
          const {data} = response;

          if (data && data.length > 0) {
            let perfisConvidado = [];

            data.forEach(x => {
              let value = x.tipoPerfil;
              let pConvidado = {
                tipoPerfil: x.tipoPerfil,
                idAtuacao: x.idAtuacao,
                ocupacao: '',
                ativo: true,
                aprovado: '',
                idEntidade: ''
              }

              if (value === TipoPerfil.CONSELHEIRO.id) {
                pConvidado = {
                  ...pConvidado,
                  conselheiroPerfil: conselheiroPerfil,
                  ocupacao: '',
                  interlocutorPerfil: null
                };
              } else if (value === TipoPerfil.EQUIPE_TECNICA.id) {
                pConvidado = {
                  ...pConvidado,
                  conselheiroPerfil: null,
                  ocupacao: '',
                  interlocutorPerfil: null
                };
              } else if (value === TipoPerfil.INTERLOCUTOR.id) {
                pConvidado = {
                  ...pConvidado,
                  conselheiroPerfil: null,
                  ocupacao: '',
                  interlocutorPerfil: interlocutorPerfil
                };
              }
              perfisConvidado.push(pConvidado);

            })

            setPerfis(perfisConvidado);
            form.idAtuacao = data.idAtuacao;
            setConvidado(true);
          } else {
            setPerfis([{
              tipoPerfil: '',
              idAtuacao: '',
              ocupacao: '',
              ativo: true,
              aprovado: '',
              idEntidade: ''
            }]);
          }
        }
      })

    } else if (tipo === 'editar') {
      setPerfis([...listaPerfis]);
    }
    recuperarAtuacoes().then(response => {
      setAtuacoes(response.data);
    });
  }, [props.initialValue])


  const buscarCep = async (cep) => {
    if (cep) {
      const novoCep = cep.replace('.', '').replace('-', '');
      if (novoCep.length === 8) {
        const response = await findByCep(novoCep);
        if (response) {
          const {data} = response;
          let endereco = `${data.cidade}/${data.siglaEstado} ${data.bairro} ${data.logradouro} `;
          if (data.erro) {
            endereco = '';
            enqueueSnackbar('O CEP informado não existe', {variant: 'error'});
          }
          setForm({...form, endereco});
          setValue('endereco', endereco);
          clearError('endereco')
        }
      } else {
        setForm({...form, endereco: ''});
        setValue('endereco', '')
      }
    }
  };


  const endereco = () => (
    <>
      <Grid item xs={12} sm={6}>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItens: 'center', height: '17px'}}>
          <FormLabel shrink="true" error={!!errors.cep}>CEP</FormLabel>
          <a
            href="http://www.buscacep.correios.com.br/sistemas/buscacep/BuscaCepEndereco.cfm"
            target="_blank"
          >
            <Typography variant="caption">Não sabe o seu cep?</Typography>
          </a>
        </div>
        <TextField
          fullWidth
          InputProps={{
            inputComponent: Mascara.cep,
          }}
          id="cep"
          name="cep"
          value={form.cep}
          onChange={handleChange}
          onBlur={() => buscarCep(form.cep)}
          variant="outlined"
          error={!!errors.cep}
          helperText={errors.cep && errors.cep.message}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Endereço"
          InputLabelProps={{shrink: true}}
          id="endereco"
          name="endereco"
          value={form.endereco}
          onChange={handleChange}
          margin="normal"
          variant="outlined"
          fullWidth
          error={!!errors.endereco}
          helperText={errors.endereco && errors.endereco.message}
        />
      </Grid>
    </>
  );

  const sanitize = async () => {
    form.celular = form.celular.replace(/\D+/g, '');
    form.telefone = form.telefone.replace(/\D+/g, '');
    form.cep = form.cep.replace(/\D+/g, '');
    perfis.forEach(x => {
      if (x.conselheiroPerfil && x.conselheiroPerfil.telefoneInterlocutor) {
        x.conselheiroPerfil.telefoneInterlocutor = x.conselheiroPerfil.telefoneInterlocutor.replace(/\D+/g, '');
      }
    })
  };

  const handleTermoPosse = (index) => async (file) => {
    let lista = [...perfis];
    lista[index].conselheiroPerfil = {
      ...lista[index].conselheiroPerfil, novoTermoPosse: true, file: await convertBase64(file),
      nomeTermoPosse: file.name, tamanhoTermoPosse: file.size, formatoTermoPosse: file.type
    };

    setPerfis([...lista]);
  }


  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file)
      fileReader.onload = () => {
        resolve(fileReader.result);
      }
      fileReader.onerror = (error) => {
        reject(error);
      }
    })
  }


  const onDeleteTermoPosse = (index) => () => {
    let lista = [...perfis];

    lista[index].conselheiroPerfil = {...lista[index].conselheiroPerfil, novoTermoPosse: false};
    lista[index].conselheiroPerfil = {...lista[index].conselheiroPerfil, idTermoPosse: undefined};

    setPerfis([...lista]);
  }

  const submit = async () => {
    await sanitize();

    if (perfis.length === 0 && (form.id == null || form.id === '')) {
      enqueueSnackbar("A lista de perfis não pode ser vazia!", {variant: 'error'});
      return;
    } else if (perfis.length > 0) {

      for (let i = 0; i < perfis.length; ++i) {
        for (let j = 0; j < perfis.length; ++j) {
          if (i !== j && perfis[i].idAtuacao === perfis[j].idAtuacao && perfis[i].tipoPerfil === perfis[j].tipoPerfil) {
            enqueueSnackbar("Existe perfis iguais para a mesma atuação!", {variant: 'error'});
            return;
          }
        }
      }
    }
/*
    upload();
  };

   const upload = async () => {
    let lista = [...perfis];

    for (const p of lista) {
      if (p.conselheiroPerfil && p.conselheiroPerfil?.file) {

        let formData = new FormData();
        formData.append("file", p.conselheiroPerfil.file)
        formData.append("nome", 'Nome Teste');
        formData.append("tipo", 'Tipo Teste');
        const response = await uploadStorage(formData);

        if (response && response.status === 200) {
          p.conselheiroPerfil = {...p.conselheiroPerfil, idStorage: response.data};
          p.conselheiroPerfil = {...p.conselheiroPerfil, file: null};
        } else {
          enqueueSnackbar("Ocorreu um erro ao cadastrar o documento!", {variant: 'error'});
          return;
        }
      }
    }

    setPerfis([...lista]);

    */
    const data = {...form, perfis: [...perfis]};

    onSubmit(data, convidado)
  }

  const validateShowUser = () => {
    let show = true;
    if (tipo !== "cadastrar" && !form.id) {
      show = false;
    }
    return show;
  }

  return (
    <FormContext register={register} errors={errors} clearError={clearError} setValue={setValue}>
      {validateShowUser() &&
      <div className={classes.formularioCorpo} style={{marginTop: `${tipo === 'editar' ? '55px' : '94px'}`}}>
        {tipo === 'editar' ? ''
          : (
            <div>
              <div className={classes.quadradoTopoDireita}/>
              <div className={classes.quadradoTopoEsquerda}/>
              <div className={classes.quadradoEsquerdo}/>
              <div className={classes.quadradoDireita}/>
              <div className={classes.quadradoBaixo}/>
            </div>
          )}
        <form onSubmit={handleSubmit(submit)}>
          <div style={{padding: '35px 15px 5px 15px'}}>
            {tipo === 'cadastrar' ? <CabecalhoCadastro form={form}/> : <CabecalhoEdicao isEditar form={form}/>}
            <Grid container spacing={2}>
              {tipo === 'cadastrar'
                ? (
                  <>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        disabled
                        fullWidth
                        label="Nome"
                        InputLabelProps={{shrink: true}}
                        id="nome"
                        name="nome"
                        margin="normal"
                        variant="outlined"
                        value={form.nome}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        disabled
                        fullWidth
                        label="Sobrenome"
                        InputLabelProps={{shrink: true}}
                        id="sobrenome"
                        name="sobrenome"
                        margin="normal"
                        variant="outlined"
                        value={form.sobrenome}
                        onChange={handleChange}
                      />
                    </Grid>
                  </>
                ) : ''}
              <Grid item xs={12} sm={6}>
                <TextField
                  disabled
                  fullWidth
                  label="Email Institucional"
                  InputLabelProps={{shrink: true}}
                  id="emailInstitucional"
                  name="emailInstitucional"
                  value={form.emailInstitucional}
                  onChange={handleChange}
                  margin="normal"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="LinkedIn (Opcional)"
                  InputLabelProps={{shrink: true}}
                  id="linkedIn"
                  name="linkedIn"
                  value={form.linkedIn}
                  onChange={handleChange}
                  placeholder="https://br.linkedin.com/usuario"
                  margin="normal"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Celular (WhatsApp)"
                  InputLabelProps={{shrink: true}}
                  InputProps={{
                    inputComponent: Mascara.celular,
                  }}
                  id="celular"
                  name="celular"
                  value={form.celular}
                  placeholder="(99) 99999-9999"
                  onChange={handleChange}
                  margin="normal"
                  variant="outlined"
                  error={!!errors.celular}
                  helperText={errors.celular && errors.celular.message}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Telefone Comercial"
                  InputLabelProps={{shrink: true}}
                  InputProps={{
                    inputComponent: Mascara.telefone,
                  }}
                  id="telefone"
                  name="telefone"
                  margin="normal"
                  variant="outlined"
                  value={form.telefone}
                  placeholder="(99) 9999-9999"
                  onChange={handleChange}
                  error={!!errors.telefone}
                  helperText={errors.telefone && errors.telefone.message}
                />
              </Grid>
              {endereco()}

              {perfis.map((item, key) => {

                if (item.ativo) {

                  return (


                    <Grid key={key} container spacing={2} className={classes.retangulo}>
                      <Grid container spacing={2} style={{padding: '16px'}}>
                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth error={!!errors.tipoPerfil}>
                            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                              <FormLabel shrink="true">Tipo de Perfil </FormLabel>
                              <InfoOutlinedIcon style={{height: '16px', width: '16px', color: '#0430ad'}}/>
                            </div>
                            <Select
                              required
                              fullWidth
                              onBlur={() => handleFormCleanValidation()}
                              id="tipoPerfil"
                              name="tipoPerfil"
                              value={item.tipoPerfil}
                              onChange={handleChangePerfil(key)}
                              variant="outlined"
                              disabled={item.id != null}
                              inputProps={{
                                margin: 'normal',
                              }}
                              IconComponent={ExpandMoreIcon}
                            >
                              <MenuItem value={TipoPerfil.CONSELHEIRO.id}>Conselheiro</MenuItem>
                              <MenuItem value={TipoPerfil.EQUIPE_TECNICA.id}>Equipe Técnica</MenuItem>
                              <MenuItem value={TipoPerfil.INTERLOCUTOR.id}>Interlocutor</MenuItem>
                            </Select>
                            {/* eslint-disable-next-line max-len */}
                            <FormHelperText>{errors.tipoPerfil && errors.tipoPerfil.message}</FormHelperText>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <InputLabel shrink>Atuação</InputLabel>
                          <Select
                            required
                            fullWidth
                            id="idAtuacao"
                            name="idAtuacao"
                            value={item.idAtuacao}
                            onChange={handleChangeLista(key)}
                            onBlur={() => verificarPerfilInativo(key, item)}
                            disabled={item.id != null}
                            variant="outlined"
                            inputProps={{
                              margin: 'normal',
                            }}
                            IconComponent={ExpandMoreIcon}
                          >

                            {atuacoes.map((uf, key) => (
                              <MenuItem key={key} value={uf.id}>{uf.descricao}</MenuItem>
                            ))}
                          </Select>
                        </Grid>

                        {item.tipoPerfil === TipoPerfil.EQUIPE_TECNICA.id ? (
                          <EquipeTecnicaForm
                            form={item}
                            onChange={handleChangeEquipeTecnicaForm(key)}
                          />
                        ) : ''}
                        {item.tipoPerfil === TipoPerfil.CONSELHEIRO.id ? (
                          <ConselheiroForm
                            form={item}
                            onChange={handleChangeConselheiroPerfil(key)}
                            handleTermoPosse={handleTermoPosse(key)}
                            handleChangeLista={handleChangeLista(key)}
                            onDeleteTermoPosse={onDeleteTermoPosse(key)}
                          />

                        ) : ''}
                        {(item.tipoPerfil === TipoPerfil.INTERLOCUTOR.id && item.idAtuacao)
                          ? (
                            // eslint-disable-next-line max-len
                            <InterlocutorForm
                              form={item}
                              perfis={perfis}
                              handleChangeLista={handleChangeLista(key)}
                              onChange={handleChangeInterlocutorPerfil(key)}/>
                          ) : ''}
                      </Grid>

                      <Grid container spacing={2} justify="flex-end" style={{padding: '16px'}}>
                        <Button
                          onClick={removerLinha(key, item.tipoPerfil)}>
                          Remover este perfil <DeleteOutlined/>
                        </Button>
                      </Grid>

                    </Grid>

                  )

                }

                return (

                  <>

                  </>

                );

              })}

              <Grid container spacing={2} className={classes.retangulo}>
                <Grid container spacing={2} justify="center" style={{padding: '16px'}}>
                  <Button
                    onClick={adicionarLinha}
                    variant="outlined"
                    className={classes.botaoFiltrar}>
                    Adicionar outro perfil </Button>
                </Grid>
              </Grid>


              <Grid item xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  className={classes.botaoConfirmar}
                >
                  {labelBotao}
                </Button>
              </Grid>
            </Grid>
          </div>
        </form>
      </div>}
    </FormContext>
  );
};

export default withRouter(UsuarioForm);
